/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";

export const MainMenuLeftContainer = React.memo(
    () => {
        console.log("Render of main menu left container called!");

        Game.Rewards.ShowMainMenuLeft();

        const screenHeight = window.innerHeight;
        const shouldUseSmallContainers = screenHeight <= 600;

        const styles = {
            border: window.location.href.includes("localhost") ? "1px solid red" : "none",
            display: "flex",
            width: shouldUseSmallContainers ? "250px" : "160px",
            height: shouldUseSmallContainers ? "250px" : "600px",
            position: "relative",
            top: shouldUseSmallContainers ? "75px" : "auto"
        } as React.CSSProperties;

        return (
            <div className="main-menu-left-container">
                <div className="main-menu-left-container-inner" id="pvpz-io_160x600_3" style={styles}></div>
            </div>
        );
    },
    (__prepProps, __nextProps) => true
);
